const FooterBrand = () => {
  return (
    <div className="max-w-sm">
      <div className="flex items-center">
        <span className="text-2xl font-bold tracking-wider">LIDER</span>
      </div>
      <p className="mt-4 text-gray-400">
        Kompleksowe rozwiązania dla właścicieli szkół językowych i lektorów.
      </p>
    </div>
  );
};

export default FooterBrand;